export default __webpack_public_path__ + "static/media/Transaction.c25a72cf.png";